export default function Footer() {
    return(
        <section id='footer'>
            <a target="_blank" href="https://www.twitter.com/adamcbowman"><i class="fab fa-twitter-square fa-2x"></i></a>
            <a target="_blank" href="https://www.facebook.com/adamcbowman"><i class="fab fa-facebook-square fa-2x"></i></a>
            {/* <i class="fab fa-instagram-square fa-2x"></i> */}
            <a target="_blank" href="https://github.com/adamcbowman"><i class="fab fa-github-square fa-2x"></i></a>
        </section>
    )
}